import { Button, Dropdown, Radio, Select } from "antd";
import { BiFilterAlt, BiSortAlt2 } from "react-icons/bi";
import searchIcon from "../../../assets/images/searchIcon.png";
import excelIcon from "../../../assets/svg/excel.svg";
import { useState } from "react";
import { IoIosArrowDown } from "react-icons/io";

const { Option } = Select;

const SortOptions = ({ sortName, handleSortClick }) => {
  const [selectedSort, setSelectedSort] = useState("newest");
  const [open, setOpen] = useState(false);

  const sortOptions = [
    { label: "Newest First", value: "newest" },
    { label: "Oldest First", value: "oldest" },
    { label: "Last Updated ", value: "updated" },
    { label: "Alphabetic A-Z", value: "ascending" },
    { label: "Alphabetic Z-A", value: "descending" },
  ];

  const handleApply = () => {
    handleSortClick(selectedSort);
    setOpen(false);
  };

  const menuItems = sortOptions.map((option) => ({
    key: option.value,
    label: (
      <div
        className="d-flex align-items-center gap-2 px-3 py-2"
        onClick={(e) => {
          e.stopPropagation();
          setSelectedSort(option.value);
        }}
      >
        <Radio checked={selectedSort === option.value} />
        <span>{option.label}</span>
      </div>
    ),
  }));

  return (
    <Dropdown
      arrow
      menu={{
        items: [
          ...menuItems,
          { type: "divider" },
          {
            key: "apply",
            label: (
              <div className="py-2" onClick={handleApply}>
                <span className="w-100 text-primarycolor fs16fw600 d-flex justify-content-center">
                  Apply
                </span>
              </div>
            ),
          },
        ],
      }}
      trigger={["click"]}
      open={open}
      onOpenChange={setOpen}
      className="sortByContent"
    >
      <Button className="d-flex align-items-center gap-2">
        Sort By <BiSortAlt2 size={18} />
      </Button>
    </Dropdown>
  );
};

const DoctorsFilterOptions = ({
  limit,
  sortName = "Sort By",
  setFilterShow,
  setSortShow,
  setLimit,
  onChange,
  handleSortClick,
  filter_records,
  downloadExcel = false,
  onClickDownload = () => {},
  showFilter = true,
  showSortBy = true,
}) => {
  const filterSortBtns = () => (
    <div className="rightContent gap-4 d-flex align-items-center">
      {showFilter && (
        <Button className="filterByBtn" onClick={() => setFilterShow(true)}>
          <span>Filter By</span>
          <BiFilterAlt size={20} />
        </Button>
      )}
      { showSortBy && (
        <SortOptions sortName={sortName} handleSortClick={handleSortClick} />
      )}

      <div>Entries</div>
      <div className="searchInputWrapper position-relative">
        <div
          className="searchImg position-absolute"
          style={{ top: "15%", left: "3%" }}
        >
          <img src={searchIcon} alt="search" />
        </div>
        <div className="searchInputText">
          <input
            type="text"
            placeholder="Search"
            className="form-control px-5 h-100"
            onChange={(e) => onChange(e.target.value)}
          />
        </div>
      </div>
    </div>
  );

  return (
    <div
      className={`filterSortOptions my-3 ${downloadExcel ? "" : "justify-content-between"}`}
    >
      <div className="leftContent d-flex align-items-center">
        <div>Show</div>
        <div>
          <Select
            suffixIcon={<IoIosArrowDown size={18} />}
            showSearch
            value={limit}
            onChange={(value) => setLimit(parseInt(value))}
            className="me-2 w-100"
          >
            <Option value={10}>10</Option>
            <Option value={25}>25</Option>
            <Option value={50}>50</Option>
            <Option value={100}>100</Option>
          </Select>
        </div>
      </div>

      {downloadExcel ? (
        <div className="d-flex w-100 justify-content-between">
          {filterSortBtns()}
          <Button onClick={onClickDownload} className="downloadExcel">
            Download <img src={excelIcon} alt="" />
          </Button>
        </div>
      ) : (
        filterSortBtns()
      )}
    </div>
  );
};

export default DoctorsFilterOptions;
